export default {"src":"/_next/static/media/deploy-prototype.7a878d46.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};